import { assign, literal, nullable, number, string, type } from "superstruct";

import InstagramBaseLayoutSchema from "./InstagramBaseLayoutSettingsSchema";

const InstagramMasonryLayoutSettingsSchema = assign(
    type({
        label: nullable(string()),
        layout: literal("masonry"),
        space: number(),
        rows: number(),
    }),
    InstagramBaseLayoutSchema
);

export default InstagramMasonryLayoutSettingsSchema;
